import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import numeral from "numeral";

import { fetchReportSummaryNudges } from "src/redux/actions/reports";

import userRoleService from "src/utils/userRoles.service";

import _ from "lodash";
import styles from "./dashBoard.module.scss";

const DashboardMetrics = () => {
  const dispatch = useDispatch();

  const reportSummary = useSelector((state: any) =>
    _.get(state, "reports.reportSummary", null),
  );

    const currency = useSelector((state: any) =>
  _.get(state, "accounts.item.currency", "")
);

  const formatDealValue = (value) => {
    return currency
    ? `${currency}${numeral(value).format("0.00a")}`
    : numeral(value).format("0.00a");
  }
  const nudgesType = [
    "assets",
    "activeUser",
    "session",
    "share",
    "contact",
    "deal",
    "lead",
  ];

  const dashBoardData = [
    {
      title: "# of \nAssets",
      value: _.get(reportSummary?.item, "assets.assets", "-"),
      requiresShareAccess: false,
    },
    {
      title: "Active \nusers",
      value: _.get(reportSummary?.item, "activeUser.activeUsers", "-"),
      requestShareAccess: false,
    },
    {
      title: "# of \nAsset views \n(team)",
      value: _.get(reportSummary?.item, "session.teamViews", "-"),
      requiresShareAccess: false,
    },
    {
      title: "# of \nconversations",
      value: _.get(reportSummary?.item, "share.shares", "-"),
      requiresShareAccess: true,
    },
    {
      title: "Engaged \nusers",
      value: _.get(reportSummary?.item, "contact.engagedContacts", "-"),
      requiresShareAccess: true,
    },
    {
      title: "# of \nLeads",
      value: _.get(reportSummary?.item, "lead.leads", "-"),
      requiresShareAccess: true,
    },
    {
      title: "# of \nDeals",
      value: _.get(reportSummary?.item, "deal.deals", "-"),
      requiresShareAccess: true,
    },
     {
      title: "Value of \nSales",
      value: formatDealValue(_.get(reportSummary?.item, "deal.dealValue", "-")),
      requiresShareAccess: true,
    },
  ];

  const filteredDashboardMetrics = dashBoardData.filter(
    (metric) =>
      !metric.requiresShareAccess || userRoleService.canShare()
  );

  useEffect(() => {
    nudgesType.forEach((type) => {
      dispatch(fetchReportSummaryNudges({ nudgesType: type }));
    });
  }, []);

  return (
    <div className={styles.metricsContainer}>
      {filteredDashboardMetrics.map((metric, index) => (
        <DashboardMetricCard
          key={index}
          title={metric.title}
          value={metric.value}
        />
      ))}
    </div>
  );
};

export default DashboardMetrics;

export interface DashboardMetricCardProps {
  title: string;
  value: string;
}

const DashboardMetricCard = ({ title, value }: DashboardMetricCardProps) => {
  return (
    <div className={styles.metricCard}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};
